const gql = String.raw;

export default gql;
